"use client";

import { useMe } from "./useConversations";

/**
 * IS THERE A SESSION — the tri-state fact the people-reads gate on (OSO-695).
 *
 * Every read that lists PEOPLE (`/groups/{ref}/members`, `/events/{id}/rsvps`,
 * `/posts/{id}/reactions`, the bot transcripts) answers a signed-out caller
 * 401, so firing those queries while signed out is asking a question whose
 * refusal is already known. This hook is what their `enabled` reads, and what
 * their "Log ind for at se …" arm derives from — one definition, so the gate
 * and the message cannot disagree.
 *
 * It is a PROJECTION of `useMe()` (`GET /me` answers `null` when signed out,
 * never an error — §1.6), so it costs no request of its own and settles the
 * moment the header's own poll has.
 *
 * `undefined` means "not answered yet" — `/me` still in flight, or failed
 * outright. Callers gate fetching on `=== true` and draw the signed-out arm
 * on `=== false`, so the unanswered state fetches nothing and accuses nobody:
 * a reader whose `/me` merely timed out must not be told to log in.
 */
export function useSignedIn(): boolean | undefined {
  const { data, isPending, isError } = useMe();
  if (isPending || isError) return undefined;
  return data != null;
}
